<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="vq_vendname"
      placeholder="输入供应商名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/document/vendor_apply/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.vq_vendname}}</p>
          <p class="list-item-muted">{{item.vq_type}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.vq_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.vq_status=='已审核'}"
          >{{item.vq_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sample/vendorQualifications/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "vq_statuscode!='AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "vq_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>